import { render, staticRenderFns } from "./AdminApps.vue?vue&type=template&id=7bef10b1"
import script from "./AdminApps.vue?vue&type=script&lang=js"
export * from "./AdminApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports